import DropDownMenu from 'material-ui/DropDownMenu';
import FlatButton from 'material-ui/FlatButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import MenuItem from 'material-ui/MenuItem';
import './styles/AgGridPaginationCtrlStyles.css';
import React from 'react';

class AgGridPaginationCtrl extends React.Component {
    constructor(props){
        super(props);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handlePreviousPageClick = this.handlePreviousPageClick.bind(this);
        this.handleNextPageClick = this.handleNextPageClick.bind(this);

        var totalPages = Math.ceil(props.totalCount / props.selectedPageSize);

        this.state = {
            selectedPageSize: props.selectedPageSize,
            pageSizeList: props.pageSizeList,
            currentPage: props.currentPage,
            totalPages: totalPages,
            totalCount: props.totalCount
        };
    }

    /**
     * cambio impaginazione
     */
    handlePageSizeChange = (event, index, value) =>{
        this.props.handlePageSizeChanged(value);
    }

    /**
     * goto alla pagina precedente
     */
    handlePreviousPageClick = (event) => {
        this.props.handlePagination(this.props.currentPage - 1);
    }

    /**
     * goto alla pagina successiva
     */
    handleNextPageClick= (event) => {
        this.props.handlePagination(this.props.currentPage + 1);
    }

    render() {
        const {translate} = this.props;
        return (
            <div className="pageSizeContainer" >
                <div className="pageSizeSubContainer">
                    <div className="pageSizeSubSubContainer">
                        <div className="pageSizeTotalCount">
                            {this.props.totalCount} {translate('GLOBAL.entries')}
                        </div>
                        <div className="pageSizeRowsPerPageLeft">
                            {translate('GLOBAL.pageSize')}
                        </div>
                        <DropDownMenu
                            value={this.state.selectedPageSize}
                            onChange={this.handlePageSizeChange}
                            className="pageSizeSelector"
                            >
                            {this.state.pageSizeList.map((rowSize) => {
                            return (
                                <MenuItem
                                key={rowSize}
                                value={rowSize}
                                primaryText={rowSize}
                                />
                            );
                            })}
                        </DropDownMenu>
                        <div className="pageSizePageCount">
                            {translate('GLOBAL.pageNo')} {<div>{this.state.currentPage} {translate('GLOBAL.pageOf')} {this.state.totalPages}</div>}
                        </div>
                        <div className="pageSizePageArrows" >
                            <FlatButton
                            icon={<ChevronLeft />}
                            onClick={this.handlePreviousPageClick}
                            disabled={this.state.currentPage === 1 ? true : false}
                            />
                            <FlatButton
                            icon={<ChevronRight />}
                            onClick={this.handleNextPageClick}
                            disabled={this.state.currentPage === this.state.totalPages ? true : false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AgGridPaginationCtrl;






// WEBPACK FOOTER //
// ./src/components/table/AgGridPaginationCtrl.js